import { useCreateReportConfiguration } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import type { CreateReportConfigurationRequestType } from 'src/api/generated/touring/types';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.ADD_REPORT_MAILING';

type UseAddReportMailingReturnType = {
  // Resolves to true on success so the caller only closes the modal then.
  addReportMailing: (
    data: CreateReportConfigurationRequestType
  ) => Promise<boolean>;
};

// The configurations refetch is triggered by the generated mutation (see orval.config.ts).
export const useAddReportMailing = (): UseAddReportMailingReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutateAsync } = useCreateReportConfiguration<AxiosError>();

  const addReportMailing = async (
    data: CreateReportConfigurationRequestType
  ) => {
    try {
      await mutateAsync({ data });
    } catch (error) {
      showError({
        title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
        error: error as AxiosError,
      });
      return false;
    }

    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
    return true;
  };

  return { addReportMailing };
};
